import React, {useContext, useEffect, useState} from 'react';
import {Grid, IconButton} from '@material-ui/core';
import {Visibility, VisibilityOff, Warning} from '@material-ui/icons';
import {CardContent} from 'components/WidgetCard';
import {PSingleLine} from 'components/TypographyShortcuts';
import {UserContext} from 'context/UserContext';
import {InlineCardInfo} from 'components/payment/CardLogoAndName';
import {useGetPaymentToken} from 'hooks/useGetEndpoint';

const CardInfoBox = () => {
    const {data, isLoading, error} = useGetPaymentToken();
    const {payment, actions} = useContext(UserContext);

    const [showCardNumber, setShowCardNumber] = useState(false);

    useEffect(() => {
        if (data) {
            actions.updatePayment(data);
        }
        //eslint-disable-next-line
    }, [data]);

    const hasPaymentCard = payment?.maskedAccount !== null;

    return (
        <Grid item xs container alignItems='center'>
            <CardContent
                hasData={payment}
                isLoading={isLoading || false}
                error={error || false}
            >
                <Grid item xs={10}>
                    <PSingleLine>
                        Current card:{' '}
                        {!hasPaymentCard ? (
                            <>
                                <Warning
                                    style={{
                                        verticalAlign: 'middle',
                                        color: 'orange',
                                    }}
                                />
                                No Card On File
                            </>
                        ) : showCardNumber ? (
                            <InlineCardInfo paymentToken={payment} />
                        ) : (
                            'xxxx-xxxx-xxxx-xxxx'
                        )}
                    </PSingleLine>
                </Grid>
                <Grid item xs={2}>
                    {hasPaymentCard && (
                        <IconButton
                            aria-label='show-cc-info'
                            onClick={() => {
                                setShowCardNumber(!showCardNumber);
                            }}
                        >
                            {showCardNumber ? (
                                <Visibility />
                            ) : (
                                <VisibilityOff />
                            )}
                        </IconButton>
                    )}
                </Grid>
            </CardContent>
        </Grid>
    );
};

export default CardInfoBox;
